<template>
  <div>
    <basic-portlet title="Live Feed Debug">
      <div class="row">
        <div class="col-6">
          <multiselect v-model="live_feed" track-by="uuid"
                       :options="filtered_live_feeds"
                       placeholder="Choose a Live Feed"
                       label="name"
                       @input="live_feed_status = checkStatus(live_feed)" />
        </div>
        <div class="col-6">
          <multiselect v-model="selected_customer" track-by="id"
                       :options="customers"
                       placeholder="Filter by customer"
                       label="name" />
        </div>
      </div>
    </basic-portlet>

    <basic-portlet v-if="live_feed" title="Feed Info">
      <template slot="portlet_actions">
        <button v-if="live_feed_status" type="button" class="btn btn-success">
          On Air
        </button>
        <button v-else type="button" class="btn btn-danger">
          Off Air
        </button>
      </template>

      <div class="row">
        <div class="col-12 col-md-6 mb-4">
          <div class="card">
            <div class="card-body">
              <strong>UUID</strong> : {{ live_feed.uuid }}<br>
              <strong>Slug</strong> : {{ live_feed.slug }}<br>
              <strong>Last Start</strong> : {{ formatDateTime(live_feed.start_at) }}<br>
              <strong>Last Stop</strong> : {{ formatDateTime(live_feed.stop_at) }}<br>
              <strong>Last Restart</strong> : {{ formatDateTime(live_feed.restart_at) }}<br>
              <strong>Initially Created</strong> : {{ formatDateTime(live_feed.created_at) }}
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6 mb-4">
          <button class="btn btn-ss" type="button" @click="control('start', live_feed, true);">
            <i class="fa fa-play" /> Start
          </button>
          <button class="btn btn-ss" type="button" @click="control('stop', live_feed, true);">
            <i class="fa fa-stop" /> Stop
          </button>
          <button class="btn btn-ss" type="button" @click="control('restart', live_feed, true);">
            <i class="fa fa-dot-circle" /> Restart
          </button>
          <br>
          <button v-if="user.is_super_admin" class="btn btn-ss-danger ss-danger mt-4"
                  type="button"
                  @click="rebuildPlsFile(live_feed)">
            <i class="fa fa-file-audio" /> Rebuild PLS File
          </button>
        </div>

        <div v-for="(playlist, playlist_index) in live_feed.premium_config.playlists"
             :key="`${live_feed.uuid}_playlist_${playlist_index}`"
             class="col-12 col-md-4 mb-4">
          <live-feed-playlist-card :playlist-index="playlist_index + 1" :playlist-data="playlist" />
        </div>

        <div v-for="(output, output_index) in live_feed.premium_config.outputs"
             :key="`${live_feed.uuid}_output_${output_index}`"
             class="col-12 col-md-4 mb-4">
          <live-feed-output-card :live-feed-uuid="live_feed.uuid" :output="output" :output-index="output_index + 1" />
        </div>
      </div>
    </basic-portlet>

    <basic-portlet v-if="live_feed" title="Logs">
      <live-feed-logs :live-feed="live_feed" />
    </basic-portlet>
    <quick-alert-modal v-bind="quick_alert" />
  </div>
</template>

<script>
import BasicPortlet from "VueComponents/BasicPortlet";
import LiveFeedsMixin from "VueMixins/Feeds/LiveFeedsMixin";
import LiveFeedLogs from "VuePartials/LiveFeeds/LiveFeedLogs";
import LiveFeedPlaylistCard from "VuePartials/LiveFeeds/LiveFeedPlaylistCard";
import LiveFeedOutputCard from "VuePartials/LiveFeeds/LiveFeedOutputCard";

export default {
  components: {
    LiveFeedOutputCard,
    LiveFeedPlaylistCard,
    LiveFeedLogs,
    BasicPortlet,
  },
  mixins: [LiveFeedsMixin],
  data() {
    return {
      selected_customer: null,
      customers: window.customers,
      live_feeds: window.live_feeds,
      user: window.user,
    };
  },
  computed: {
    filtered_live_feeds() {
      if (!this.selected_customer) {
        return this.live_feeds;
      }
      return _.filter(this.live_feeds, lf => lf.customer.slug === this.selected_customer.slug);
    },
  },
};
</script>
